import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.assessmentCycleTable.title',
    defaultMessage: 'Evaluation cycle',
  },
  applications: {
    id: 'reports.assessmentCycleTable.applications',
    defaultMessage: 'Applications',
  },
  performance: {
    id: 'reports.assessmentCycleTable.performance',
    defaultMessage: 'Performance',
  },
  schoolCriteria: {
    id: 'reports.assessmentCycleTable.schoolCriteria',
    defaultMessage: 'School Criteria',
  },
  appliedIn: {
    id: 'reports.assessmentCycleTable.appliedIn',
    defaultMessage: 'Applied In',
  },
  applicationAbbreviation: {
    id: 'reports.assessmentCycleTable.applicationAbbreviation',
    defaultMessage: 'LC | CH | CN | MT',
  }
});
